import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Country, membership_value_model } from "../models/Country";
import { States } from '../models/States';
import { Observable, of, throwError } from 'rxjs';
import { RestApi } from '../shared/apiUrls';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CountriesService {

    constructor(private readonly http: HttpClient) { }
    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    getCountries(providerId?: string, group_by?: boolean): Observable<Country[]> {
        let params = new HttpParams();
        if (group_by != null) {
            params = new HttpParams().append("group_by", group_by.toString())
        }
        if (providerId != null) {
            params = params.append("providerId", providerId)
        }
        return this.http.get<Country[]>(RestApi.Urls.CountryApi + 'GetAllSupported', { params: params }).pipe(catchError(this.handleError));
    }
    getAllCountries(): Observable<Country[]> {
        return this.http.get<Country[]>(RestApi.Urls.CountryApi + 'GetAll').pipe(catchError(this.handleError));
    }

    getStates(country_id: number): Observable<States[]> {
        return this.http.get<States[]>(RestApi.Urls.CountryApi + 'GetStates/' + country_id).pipe(catchError(this.handleError));
    }

    async GetMembershipValues(): Promise<membership_value_model[]> {
        return await this.http.get<any>('assets/data/currency_rates.json')
            .toPromise()
            .then(res => res.data as membership_value_model[])
            .then(data => data);

    }
}
